import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Save = () => {
    document.title = "Yadda saxla";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Yadda saxla", value: "/common/save", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Yadda saxla</h2>
                    <p>
                        Bütün əməliyyatlar <SaveButton /> düyməsini sıxmaqla tamamlanır. <SaveButton /> düyməsi sıxılmadan <Button>Bağla</Button> düyməsi ilə
                        bağlanan səhifədə dəyişikliklər (əlavə olunan məhsullar, dəyişilmiş miqdar, və s.) yadda saxlanılmır.
                    </p>
                    <img src="/images/common/save.gif" alt="Yadda saxla" />
                </article>
            </div>
        </div>
    );
};
